<template>
    <div :class="['help', { open: isOpen }]" aria-live="polite">
        <button 
            ref="helpButton" 
            @click="goToHelp" 
            :aria-label="$t('action-buttons.help')" 
            class="help__button"
            :aria-expanded="isOpen"
        >
            <span
                class="btn-icon icon-help"
                aria-hidden="true"
            ></span>
        </button>
        <div 
            class="help__panel" 
            ref="helpPanel" 
            role="dialog"
            aria-modal="true"
            :aria-label="$t('action-buttons.help')"
            tabindex="-1" 
            :aria-hidden="!isOpen"
            @keydown="trapFocus"
        >
            <button 
                ref="closeButton"
                @click="closeHelp" 
                :aria-label="$t('aria-labels.help-panel')" 
                class="help__button help__button--close"
                tabindex="-1" 
            >
                <font-awesome-icon :icon="['far', 'circle-xmark']" />
            </button>
            <div class="help__panel__content" ref="helpPanelContent" tabindex="-1">
                <safe-html class="form-result-message" :htmlContent="$t(stepDescriptionText)"/>
            </div>
        </div>
    </div>
</template>

<script>

import sharedService from '@/services/sharedService';
import SafeHtml from '@/components/utils/SafeHtml.vue';

export default {
    name: 'HelpPanel',
    data() {
        return {
            isOpen: false,
            stepDescriptionText: sharedService.sharedState.description
        };
    },
    methods: {
        goToHelp() {
            this.isOpen = true;
            document.body.style.overflow = 'hidden';
            this.$nextTick(() => {
                const closeButton = this.$refs.closeButton;
                closeButton.focus();
                closeButton.setAttribute("tabindex", "0");
                const helpPanel = this.$refs.helpPanel; 
                const helpPanelContent = this.$refs.helpPanelContent;
                helpPanel.setAttribute("tabindex", "0");
                helpPanelContent.setAttribute("tabindex", "0");
                helpPanel.querySelector('.help__button').setAttribute("tabindex", "0");  
                const links = helpPanel.querySelectorAll("a");
                links.forEach(link => link.setAttribute("tabindex", "0")); 
            });          
        },
        closeHelp() {
            this.isOpen = false;
            document.body.style.overflow = '';
            this.$nextTick(() => {
                this.$refs.helpButton.focus();
                const helpPanel = this.$refs.helpPanel; 
                const helpPanelContent = this.$refs.helpPanelContent;
                helpPanel.setAttribute("tabindex", "-1");    
                helpPanelContent.setAttribute("tabindex", "-1");
                helpPanel.querySelector('.help__button').setAttribute("tabindex", "-1"); 
                const links = helpPanel.querySelectorAll("a");
                links.forEach(link => link.setAttribute("tabindex", "-1"));              
            });
        },
        initialTabIndex() {
            const helpPanel = this.$refs.helpPanel; 
            const links = helpPanel.querySelectorAll("a");
            links.forEach(link => link.setAttribute("tabindex", "-1"));  
        },
        trapFocus(event) {
            if (!this.isOpen) return;

            const focusableElements = this.$refs.helpPanel.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (event.key === 'Tab') {
                if (event.shiftKey) {
                    if (document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement.focus();
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        event.preventDefault();
                        firstElement.focus();
                    }
                }
            }
        }
    },
    mounted() {
        this.initialTabIndex();
    },
    components: {
        SafeHtml
    }
};
</script>
